import * as fs from 'fs/promises';
import * as path from 'path';

/**
 * 抽象文件系统接口定义
 */
export interface IFileSystem {
  readDirectory(dirPath: string): Promise<string[]>;
  stat(filePath: string): Promise<{isDirectory(): boolean}>;
  readFile(filePath: string): Promise<string>;
  writeFile(filePath: string, content: string): Promise<void>;
}

/**
 * 基于 Node.js 官方 fs/promises 的真实文件系统实现
 * 拥有操作系统绝对读写权限，解决客户端沙箱受限问题
 */
export class NodeFileSystem implements IFileSystem {
  /**
   * 读取指定目录下的所有文件和文件夹
   * @param dirPath 目录绝对路径
   */
  async readDirectory(dirPath: string): Promise<string[]> {
    const entries = await fs.readdir(dirPath, {withFileTypes: true});
    return entries.map(e => (e.isDirectory() ? `[DIR] ${e.name}` : `[FILE] ${e.name}`));
  }

  /**
   * 获取文件或目录的元数据状态
   * @param filePath 文件路径
   */
  async stat(filePath: string): Promise<{isDirectory(): boolean}> {
    const stats = await fs.stat(filePath);
    return {
      isDirectory: () => stats.isDirectory(),
    };
  }

  /**
   * 读取文件的文本内容
   * @param filePath 文件路径
   */
  async readFile(filePath: string): Promise<string> {
    return await fs.readFile(filePath, 'utf-8');
  }

  /**
   * 向指定路径写入或创建文件（自动递归创建父目录）
   * @param filePath 文件路径
   * @param content 写入的文本内容
   */
  async writeFile(filePath: string, content: string): Promise<void> {
    const dir = path.dirname(filePath);
    await fs.mkdir(dir, {recursive: true});
    await fs.writeFile(filePath, content, 'utf-8');
  }
}
